
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getSectorDetails } from './client/sector-details';
import { mapPaginatorData } from '../utils/data-mappers';



export const useSectorCompaniesQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SCREENS + '/'+params.slug, params],
    queryFn: () => getSectorDetails.get( { id:params.slug, ...params } ),
    keepPreviousData: true,
  });
  console.log("Sector details data:", data);
  return {
    product: data?.data,
    sectorDetails: data ? data.sector : undefined,
    sector_tree: data?.sector_tree,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useSectorQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: [API_ENDPOINTS.SECTORS, params],
    queryFn: () => getSectorDetails.all( params ),
    keepPreviousData: true,
  });
  console.log("Sectors list data:", params, data);
  return {
    sectors: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    tree: data?.tree,
    error,
    isLoading,
  };
};
